import { InfoType } from "~/features/info-panel/model/useInfoPanel";
import { MapObject } from "../ui/map-view";
import { useMap } from "react-leaflet";
import { useRef } from "react";
import { useEffect } from "react";

export const AutoZoomToSelectedObject: React.FC<{
  objects?: MapObject[];
  trucks?: MapObject[];
  infoId: string | null;
  infoType: InfoType | null;
}> = ({ objects, trucks, infoId, infoType }) => {
  const map = useMap();
  const prevSelection = useRef<{ id: string | null; type: InfoType | null }>({
    id: null,
    type: null,
  });

  useEffect(() => {
    if (!infoId || !infoType) {
      prevSelection.current = { id: null, type: null };
      return;
    }

    // Check if selection changed
    if (prevSelection.current.id === infoId && prevSelection.current.type === infoType) {
      return;
    }

    // Find the selected object
    let selectedObject: MapObject | undefined;

    if (infoType === "truck" && trucks) {
      selectedObject = trucks.find((t) => String(t.id) === String(infoId));
    } else if (objects) {
      selectedObject = objects.find((o) => String(o.id) === String(infoId) && o.type === infoType);
    }

    // Zoom to the object
    if (selectedObject) {
      map.setView([selectedObject.lat, selectedObject.lon], 17, {
        animate: true,
      });
      prevSelection.current = { id: infoId, type: infoType };
    }
  }, [infoId, infoType, objects, trucks, map]);

  return null;
};
